import React from "react";

import {
    Modal,
    Button,
    Table,
    Tag,
    Space,
    Typography
} from "antd";

import {
    FilePdfOutlined,
    HistoryOutlined
} from "@ant-design/icons";


import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFDownloadLink
} from "@react-pdf/renderer";


import {
    motion
} from "framer-motion";



const {
    Title,
    Text: AntText
} = Typography;



const styles = StyleSheet.create({

    page:{
        padding:30,
        fontSize:12
    },

    header:{
        textAlign:"center",
        marginBottom:20
    },

    title:{
        fontSize:18,
        marginBottom:10
    },

    row:{
        flexDirection:"row",
        paddingVertical:8,
        borderBottom:"1px solid #cccccc"
    },

    cell:{
        flex:1,
        textAlign:"center"
    }

});





const PromotionPDF = ({student}) => {


    const history =
        student?.promotion_history || [];



return (

<Document>

<Page
size="A4"
style={styles.page}
>


<View style={styles.header}>

<Text style={styles.title}>
Student Promotion History
</Text>


<Text>
{student?.full_name || "-"}
</Text>


</View>



<Text>
Promotion Records
</Text>




<View style={styles.row}>


<Text style={styles.cell}>
#
</Text>


<Text style={styles.cell}>
Previous Class
</Text>


<Text style={styles.cell}>
Promoted Class
</Text>


<Text style={styles.cell}>
Academic Year
</Text>


<Text style={styles.cell}>
Division
</Text>



</View>




{
history.map((item,index)=>(


<View
key={index}
style={styles.row}
>


<Text style={styles.cell}>
{index+1}
</Text>


<Text style={styles.cell}>
{item.previous_class || "-"}
</Text>


<Text style={styles.cell}>
{item.grade || "-"}
</Text>


<Text style={styles.cell}>
{item.academic_year || "-"}
</Text>


<Text style={styles.cell}>
{item.division || "-"}
</Text>



</View>


))


}



</Page>


</Document>

);

};









const PromotionHistoryPDF = ({
    open,
    student,
    onClose
}) => {


if(!student)
return null;



const history =
    student.promotion_history || [];



return (

<Modal

open={open}

footer={null}

width={900}

onCancel={onClose}

>


<motion.div

initial={{
opacity:0,
scale:.8
}}

animate={{
opacity:1,
scale:1
}}

transition={{
duration:.3
}}

>


<Title level={3}>

<HistoryOutlined/>

{" "}

Promotion History

</Title>



<AntText strong>
Student:
</AntText>


{" "}

{student.full_name}



<Table

style={{
marginTop:20
}}

pagination={false}


dataSource={history}


rowKey={(record,index)=>
`${record.student_name}-${index}`
}



locale={{

emptyText:"No promotion history found"

}}



columns={[


{
title:"#",

render:(_,__,index)=>
index+1

},



{
title:"Student",

dataIndex:"student_name",

render:(value)=>(

<Tag color="purple">
{value || "-"}
</Tag>

)

},



{
title:"Previous Class",

dataIndex:"previous_class",

render:(value)=>(

<Tag color="default">
{value || "-"}
</Tag>

)

},



{
title:"Promoted Class",

dataIndex:"grade",

render:(value)=>(

<Tag color="orange">
{value || "-"}
</Tag>

)

},



{
title:"Academic Year",

dataIndex:"academic_year",

render:(value)=>(

<Tag color="blue">
{value || "-"}
</Tag>

)

},



{
title:"Division",

dataIndex:"division",

render:(value)=>(

<Tag color="green">
{value || "-"}
</Tag>

)

},



{
title:"Date",

dataIndex:"promoted_date",

render:(value)=>(

value
?
new Date(value).toLocaleDateString()
:
"-"

)

}


]}



/>






<Space

style={{
marginTop:25
}}

>


<PDFDownloadLink

document={
<PromotionPDF
student={student}
/>
}


fileName={
`${student.full_name}_promotion_history.pdf`
}


>


{
({loading})=>(

<Button

type="primary"

icon={<FilePdfOutlined/>}

>

{
loading
?
"Preparing PDF..."
:
"Download PDF"
}


</Button>

)

}


</PDFDownloadLink>




<Button
onClick={onClose}
>

Close

</Button>



</Space>



</motion.div>


</Modal>

);

};



export default PromotionHistoryPDF;